import React, { useEffect, useState } from "react";
import { ReactComponent as FullscreenBtn } from "./icons/fullscreen.svg";
import { ReactComponent as BackBtn } from "./icons/back.svg";
import cssIf from "../../../scripts/helpers/class.add.if";
import numberSpaces from "../../../scripts/helpers/numbers.with.spaces";
import twoDigitFormat from "../../../scripts/helpers/two.digit.format";
import useReloadDummy from "../../../scripts/hooks/use.reload.dummy";
import { CURRENCY_SYMBOL } from "../../../settings/constants";
import useGlobal from "../../../store";
import './history.scss';

const History = () => {
  
  const [ globalState, globalActions ] = useGlobal();
  const [ Dummy, reloadDummy ] = useReloadDummy();
  const { currency, history } = globalState;
  const { deals } = globalActions;

  const [ fullscreen, setFullscreen ] = useState( false );

  const [ limit, setLimit ] = useState( 4 );
  const offset = 4;

  useEffect(() => { reloadDummy(); }, [ history, history.length ]);

  useEffect(() => {

    document.body.style.overflowX = fullscreen ? 'hidden' : 'auto';
    document.body.style.overflowY = fullscreen ? 'hidden' : 'auto';

  }, [ fullscreen ]);

  const showMore = () => setLimit( limit + offset );

  return(

    <div className={`history ${ cssIf( fullscreen, 'history--fullscreen' ) }`}>

      <div className = "history__title flex items-center">

        { fullscreen &&
          
          <BackBtn 

            className = "history__title__btn history__title__btn_left"
            title = "Назад"
            onClick = { () => setFullscreen( false ) }

          />
          
        }

        История { fullscreen ? "успеха" : "сделок" }

        { !fullscreen &&
        
          <FullscreenBtn 

            className = "history__title__btn history__title__btn_right"
            title = "На весь экран"
            onClick = { () => setFullscreen( true ) }

          />
          
        }

      </div>

      <div className = "col_name col_name_minifed">

        <div className = "col history_col1">

          Тип

        </div>

        <div className = "col history_col2">

          Время

        </div>

        <div className = "col history_col3">

          Акция

        </div>

        <div className = "col history_col4">

          Результат

        </div>  

      </div>

      <div className = "row_container">

        <Dummy />

        { history.length > 0 && history.map(( el, key ) => (

          ( key <= limit || fullscreen ) &&

          <div className = "row_container__day" key = { key }>

            <div className = "row_container__day__deals">

              { el.orders.map(( order, key ) => (

                <HistoryElement

                  key = { key }
                  type = { order.type === 1 ? "лонг" : "шорт" }
                  stock = { order.name }
                  amount = { order.amount }
                  result = { order.result }
                  comment = { order.comment }
                  currency = { CURRENCY_SYMBOL[ currency ] }
                  datetime = { order.date_update }
                  action = { () => deals.view( order ) }

                />

              ))}

            </div>

            <div className = "col_name col_name_fullscreen">

              <div className = "col history_col1">

                Тип

              </div>

              <div className = "col history_col2">

                Время

              </div>

              <div className = "col history_col3">

                Акция

              </div>

              <div className = "col history_col4">

                Результат

              </div>  

            </div>

            <div className = "total_container">

              <div className = "total_data flex">
                <div className = "text">Итог</div> { el.date }: 
              </div>

              <br className = "mobile" />

              <div className = "count">
                { el.orders.length } <span>{`->`}</span>
              </div>

              <div className={`amount amount--${ cssIf( el.result.toString().indexOf('-') === -1, "plus", "minus" ) }`}>
                { numberSpaces( el.result.toString().indexOf('.') !== -1 ? parseFloat( el.result ).toFixed( 2 ) : el.result ) } { CURRENCY_SYMBOL[ currency ] }
              </div>

            </div>

          </div>

        ))}

        {( !fullscreen || limit >= history.length ) &&

          <div 

            className="text-center" 
            onClick = { showMore }
            onMouseEnter = { showMore }

          >
            
            Показать ещё
            <br />
            <br />

          </div>
          
        }
                
      </div>

    </div>

  );
}

export const HistoryElement = ({ type, datetime, result, currency, stock, amount = 0, comment = "", action = false }) => {

  let time;

  if ( typeof datetime === "string" && datetime?.indexOf(" ") !== -1 ) {

    time = datetime.split( " " )[ 1 ];

  } else {
      
    let d = datetime;

    if ( typeof d === "string" ) { d = new Date( d ); }

    time = `${ twoDigitFormat( d.getHours() ) }:${ twoDigitFormat( d.getMinutes() ) }`;
  
  }

  return(

    <div 

      className = {`history_element ${ cssIf(result.toString().indexOf("-") === -1, "plus", "minus") } ${ cssIf( comment && comment !== "", `history_element--with-comment` ) }`}
      title = { comment }
      onClick = { () => action && action() }
      
    >

      <div className = "text data">

        { type }

      </div>

      <div className = "text time">

        { time }

      </div>

      <div className = "text stock">

        <p>{ stock }</p> { amount > 0 && <span>({ amount })</span> }

      </div>

      <div className = "text result">

      { cssIf( result.toString().indexOf("-") === -1, "+" )}{ numberSpaces( result ) } { currency }

      </div>

    </div>

  );
}

export default History;